module.exports = __webpack_public_path__ + "fb62320fa9aaf40b8a2126c74c84f543.svg";